<div class="d-flex justify-content-center">
  <div class="h3 mx-2">Live View</div>
  <div class="h3 mx-2 text-primary"><i class="fa-solid fa-camera-cctv"></i></div>
</div>
<ngx-datatable class="material striped user-page-list-table" [rows]="divisionUsers"
   [headerHeight]="40" [footerHeight]="40" [rowHeight]="35" [scrollbarV]="true" [columnMode]="columnMode.force">
  <ngx-datatable-column [cellClass]="getCellClass" [headerClass]="text-center" *ngFor="let column of tableColumns; let i = index"
  name="{{column.name}}" prop="{{column.prop}}" [width]="column.width">
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'initials'">
      <div class=" w-100 d-flex justify-content-center">
        <span  class="badge rounded-pill bg-white user-page-list-border mx-2 my-0 p-0" [ngStyle]="{'border-color': row.backgroundColor}" >
          <span class="badge rounded-pill text-white font-weight-normal m-0 p-2 user-page-list-text user-page-list-border" [ngStyle]="{'background-color': row.backgroundColor}" >
            {{ value}}
          </span>
        </span>
      </div>
    </ng-template>
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'timestamp'">
      {{value | date: 'medium'}}
    </ng-template>
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'url'" let-rowIndex="rowIndex">
      <span class="text-primary" role="button" (click)="redirectTo(value)" [attr.data-testid]="'user-page-tracking-redirect-to-' + i + '-' + rowIndex">
        <u>{{value}}</u>
      </span>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>


// WEBPACK FOOTER //
// ./src/app/core/components/user-tracking/user-page-tracking/user-page-tracking.component.html